import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
// import { API_URL } from "../../config/config";

const API_URL = process.env.REACT_APP_API_URL;

// Helper to get the token from Redux or storage
const getAuthToken = (getState) =>
  (getState && getState().auth && getState().auth.token) ||
  sessionStorage.getItem("access_token") ||
  localStorage.getItem("access_token");

export const fetchLatestBattery = createAsyncThunk(
  "battery/fetchLatest",
  async (patientId, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.get(
        `${API_URL}/vitals/patient/${patientId}/battery/latest`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch battery data");
    }
  }
);

const batterySlice = createSlice({
  name: "battery",
  initialState: { data: null, loading: false, error: null },
  reducers: {
    clearBattery(state) {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLatestBattery.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLatestBattery.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchLatestBattery.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { clearBattery } = batterySlice.actions;

export const selectBattery = (state) => state.battery;

export default batterySlice.reducer;



// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
// // import { API_URL } from "../../config/config";

// const API_URL = process.env.REACT_APP_API_URL;

// export const fetchLatestBattery = createAsyncThunk(
//   "battery/fetchLatest",
//   async (patientId, thunkAPI) => {
//     try {
//       const response = await axios.get(
//         `${API_URL}/vitals/patient/${patientId}/battery/latest`
//       );
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue("Failed to fetch battery data");
//     }
//   }
// );

// const batterySlice = createSlice({
//   name: "battery",
//   initialState: { data: null, loading: false, error: null },
//   reducers: {
//     clearBattery(state) {
//       state.data = null;
//       state.loading = false;
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchLatestBattery.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchLatestBattery.fulfilled, (state, action) => {
//         state.data = action.payload;
//         state.loading = false;
//       })
//       .addCase(fetchLatestBattery.rejected, (state, action) => {
//         state.error = action.payload;
//         state.loading = false;
//       });
//   },
// });

// export const { clearBattery } = batterySlice.actions;

// export const selectBattery = (state) => state.battery;

// export default batterySlice.reducer;
